export default "__VITE_ASSET__C$mjJ2Vl__"